import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import ButtonLoader from '../ButtonLoader/ButtonLoader.js';

const Button = (_param)=>{
    var { children , className , type ='button' , variant , size , loading , loadingLabel  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "type",
        "variant",
        "size",
        "loading",
        "loadingLabel"
    ]);
    const classes = React.useMemo(()=>classnames('btn', `btn--${variant}`, {
            [`btn--${size}`]: variant !== 'ghost' && size && size !== 'medium'
        }, className)
    , [
        className,
        variant,
        size
    ]);
    const a11y = React.useMemo(()=>{
        if (!loading) {
            return {};
        }
        return swcHelpers.objectSpread({
            role: 'status',
            'aria-live': 'polite'
        }, loadingLabel && {
            'aria-label': loadingLabel
        });
    }, [
        loading,
        loadingLabel
    ]);
    return /*#__PURE__*/ React.createElement("button", swcHelpers.extends({
        type: type,
        className: classes
    }, props, a11y), loading && /*#__PURE__*/ React.createElement(ButtonLoader, null), /*#__PURE__*/ React.createElement("span", null, children));
};

export { Button as default };
//# sourceMappingURL=Button.js.map
